module.exports = __webpack_public_path__ + "437a30d2a6e3344baf76d96a3a82aea8.svg";